<template>
  <div class="footer">
    <!-- <p class="copyright">{{ Copyright }}</p>
    <p>{{ addr }}</p> -->
    <p>联系我们: 邮箱(uniquefengzi@gmail.com)</p>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  setup() {
    const Copyright = ref('Copyright ©️  XY')
    const addr = ref('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx')
    return {
      Copyright,
      addr
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 158px;
  background: #f5f5f5;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 1px;
    width: 100%;
    // border-top: 1px solid #cccccc;
    box-shadow: 0 0 2px #cccccc;
  }
  .copyright {
    padding-bottom: 5px;
  }
}
</style>
